<div class="w-full">
  <!-- Search Bar -->
  <div class="glass-card p-4 rounded-2xl mb-6">
    <div class="flex flex-col md:flex-row gap-4 items-start md:items-center">
      <div class="relative flex-1 max-w-md">
        <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <span class="material-icons text-xl text-text-muted">search</span>
        </div>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          placeholder="Suche nach Mitarbeiter-Nr., Name oder QR Token..."
          class="search-input w-full pl-12 pr-10 py-3 rounded-xl bg-white/8 border border-white/12 text-text-primary placeholder-text-muted focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all"
        />
        @if (searchTerm) {
          <button
            type="button"
            class="absolute inset-y-0 right-0 pr-4 flex items-center text-text-muted hover:text-text-primary transition-colors"
            (click)="clearSearch()"
          >
            <span class="material-icons text-xl">close</span>
          </button>
        }
      </div>

      <div class="md:ml-auto">
        <button type="button" class="btn-primary flex items-center gap-2" (click)="openCreateModal()">
          <span class="material-icons text-xl">add</span>
          Benutzer hinzufügen
        </button>
      </div>
    </div>
  </div>

  <!-- Users Table -->
  <div class="glass-card rounded-2xl overflow-hidden">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="flex items-center justify-center py-20">
        <div class="animate-spin rounded-full h-8 w-8 border-2 border-primary border-t-transparent"></div>
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead>
            <tr class="border-b border-white/10">
              <th class="table-header" (click)="onSort('employeeId')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Mitarbeiter-Nr.
                  <span class="material-icons text-lg">{{ getSortIcon('employeeId') }}</span>
                </div>
              </th>
              <th class="table-header" (click)="onSort('firstname')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Vorname
                  <span class="material-icons text-lg">{{ getSortIcon('firstname') }}</span>
                </div>
              </th>
              <th class="table-header" (click)="onSort('lastname')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Nachname
                  <span class="material-icons text-lg">{{ getSortIcon('lastname') }}</span>
                </div>
              </th>
              <th class="table-header" (click)="onSort('qrToken')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  QR Token
                  <span class="material-icons text-lg">{{ getSortIcon('qrToken') }}</span>
                </div>
              </th>
              <th class="table-header" (click)="onSort('role')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Rolle
                  <span class="material-icons text-lg">{{ getSortIcon('role') }}</span>
                </div>
              </th>
              <th class="table-header" (click)="onSort('state')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Status
                  <span class="material-icons text-lg">{{ getSortIcon('state') }}</span>
                </div>
              </th>
              <th class="table-header">
                <span class="sr-only">Aktionen</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @if (users.length === 0) {
              <tr>
                <td colspan="7" class="px-6 py-12 text-center text-text-muted">Keine Benutzer gefunden...</td>
              </tr>
            } @else {
              @for (user of users; track user._id) {
                <tr class="table-row border-b border-white/6 last:border-b-0">
                  <td class="table-cell font-medium text-text-primary">{{ user.employeeId }}</td>
                  <td class="table-cell">{{ user.firstname }}</td>
                  <td class="table-cell">{{ user.lastname }}</td>
                  <td class="table-cell">
                    <div class="flex items-center gap-2">
                      <span class="text-xs bg-white/8 px-2 py-1 rounded">{{ user.qrToken || '—' }}</span>
                      @if (user.qrToken) {
                        <button
                          type="button"
                          class="p-1 rounded-md text-text-muted hover:text-text-primary hover:bg-white/10 transition-all"
                          (click)="copyQrToken(user.qrToken)"
                          title="QR Token kopieren"
                        >
                          <span class="material-icons text-base">content_copy</span>
                        </button>
                        <button
                          type="button"
                          class="p-1 rounded-md text-text-muted hover:text-text-primary hover:bg-white/10 transition-all"
                          (click)="openQrCodePreview(user)"
                          title="QR-Code anzeigen"
                        >
                          <span class="material-icons text-base">qr_code_2</span>
                        </button>
                      }
                    </div>
                  </td>
                  <td class="table-cell">
                    <span
                      class="inline-block px-2.5 py-1 rounded-full text-xs font-semibold"
                      [ngClass]="user.role === UserRole.ADMIN ? 'bg-purple-400/15 text-purple-400' : 'bg-blue-400/15 text-blue-400'"
                    >
                      {{ getRoleName(user.role) }}
                    </span>
                  </td>
                  <td class="table-cell">
                    <span
                      class="inline-block px-2.5 py-1 rounded-full text-xs font-semibold"
                      [ngClass]="user.state === UserState.ACTIVE ? 'bg-emerald-400/15 text-emerald-400' : 'bg-red-400/15 text-red-400'"
                    >
                      {{ getStateName(user.state) }}
                    </span>
                  </td>
                  <td class="table-cell">
                    <button
                      type="button"
                      class="p-2 rounded-lg text-text-muted hover:text-primary hover:bg-white/10 transition-all flex items-center justify-center"
                      (click)="openEditModal(user)"
                      title="Bearbeiten"
                    >
                      <span class="material-icons text-lg">edit</span>
                    </button>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      @if (totalItems > 0) {
        <div class="px-6 py-4 border-t border-white/10">
          <app-pagination
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      }
    }
  </div>
</div>

@if (qrPreviewToken) {
  <app-qr-code-preview-modal [qrToken]="qrPreviewToken" [label]="qrPreviewLabel" (close)="closeQrCodePreview()"></app-qr-code-preview-modal>
}
